import axios from "axios";
import * as yup from "yup";
import { useFormik } from "formik";
import React, { useState } from "react";

import {
  Grid,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  FormControl,
  DialogActions,
  DialogContent,
  FormHelperText,
} from "@material-ui/core";

import Loader from "../components/Loader";

export default function DeviceKFilterExceptionForm({
  initialData,
  deviceSerial,
  setMessage,
  setError,
  open,
  handleOpen,
  callback,
}) {
  const [loading, setLoading] = useState(false);

  const validateIPAddress = (address) => {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        address
      )
    ) {
      return true;
    }

    return false;
  };

  const validationSchema = yup.object({
    rule_id: yup.string("Rule ID").required("Rule ID is required"),
    ip_address: yup
      .string("IP Address")
      .required("IP Address is required")
      .test("validate-ip", "Invalid IP address", validateIPAddress),
  });

  const addException = (ruleId, requestData) => {
    setLoading(true);

    axios
      .post(`/device/kfilter/exception/${deviceSerial}/${ruleId}`, requestData)
      .then((response) => {
        setMessage("Added KFilter exception successfully.");
      })
      .catch((error) => {
        setError(error?.response?.data?.detail || "Error adding exception");
      })
      .finally(() => {
        formik.setSubmitting(false);
        handleOpen(null);
        setLoading(false);
        callback && callback();
      });
  };

  const formik = useFormik({
    initialValues: initialData || { rule_id: "", ip_address: "" },
    validationSchema: validationSchema,
    validateOnChange: true,
    onSubmit: (values) => {
      addException(values.rule_id, { ip_address: values.ip_address });
    },
  });

  if (loading) {
    return <Loader />;
  } else {
    return (
      <React.Fragment>
        <Dialog
          open={open}
          onClose={() => handleOpen(null)}
          aria-labelledby="form-dialog-title"
          maxWidth="sm"
        >
          <DialogTitle id="form-dialog-title">
            Add KFilter Exception
          </DialogTitle>
          <DialogContent>
            <Grid container direction="column" spacing={2}>
              <Grid item xs={12} sm={12}>
                <FormControl
                  error={Boolean(formik.errors.rule_id)}
                  sx={{ width: "100%" }}
                >
                  <TextField
                    fullWidth
                    margin="dense"
                    id="rule_id"
                    label="Rule ID"
                    onChange={formik.handleChange}
                    placeholder="Rule ID"
                    value={formik.values.rule_id}
                  />
                  {Boolean(formik.errors.rule_id) && (
                    <FormHelperText id="rule_id-error-text">
                      {formik.errors.rule_id}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl
                  error={Boolean(formik.errors.ip_address)}
                  sx={{ width: "100%" }}
                >
                  <TextField
                    fullWidth
                    margin="dense"
                    id="ip_address"
                    label="IP Address"
                    onChange={formik.handleChange}
                    placeholder="IP Address"
                    value={formik.values.ip_address}
                  />
                  {Boolean(formik.errors.ip_address) && (
                    <FormHelperText id="ip_address-error-text">
                      {formik.errors.ip_address}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={loading || formik.isSubmitting}
              onClick={() => formik.submitForm()}
              variant="contained"
              color="primary"
            >
              Add Exception
            </Button>
            <Button onClick={() => handleOpen(null)} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
